import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid } from "@material-ui/core";
import { OBRAS_SOCIALES, STEPPER_RECETAS } from "../../../utils/constants";
import {
  setActiveStep,
  cleanAfiliadoSeleccionado,
  clearReducer,
} from "../../../actions/recetasDigitales/RecetasDigitales";
import { RecetasDigitalesStepper } from "../UI/RecetasDigitalesStepper";
import { RecetasDigitalesAfiliadoBuscador } from "./RecetasDigitalesAfiliadoBuscador";
import { RecetasDigitalesAccordionHistorialRecetas } from "./Accordions/RecetasDigitalesAccordionHistorialRecetas";
import { RecetasDigitalesDatosTitular } from "./RecetasDigitalesDatosTitular";
import { RecetasDigitalesDetalleOrden } from "./RecetasDigitalesDetalleOrden";
import { RecetasDigitalesMedicamentos } from "./RecetasDigitalesMedicamentos";
import { RecetasDigitalesConfirmacion } from "./RecetasDigitalesConfirmacion";

export const RecetasDigitalesIngresoHome = (props) => {
  const { obraSocial } = props
  const dispatch = useDispatch();
  const { activeStep = 0 } = useSelector((state) => state.recetasDigitales);
  const [idObraSocial, setIdObraSocial] = useState(obraSocial ? obraSocial : OBRAS_SOCIALES.OSPEDYC);

  const cleanState = () => {
    dispatch(setActiveStep(STEPPER_RECETAS.BUSCADOR));
    dispatch(cleanAfiliadoSeleccionado());
    dispatch(clearReducer());
  };

  useEffect(() => {
    if (!props.fromGestion) cleanState();
  }, []);

  console.log(obraSocial);
  console.log(idObraSocial)
  return (
    <React.Fragment>
      <Grid item xs={12}>
        <RecetasDigitalesStepper activeStep={activeStep} />
      </Grid>
      {activeStep === STEPPER_RECETAS.DATOS_TITULAR && (
        <Grid item xs={12}>
          <RecetasDigitalesAccordionHistorialRecetas idObraSocial={idObraSocial} />
        </Grid>
      )}
      <Grid item xs={11}>
        {activeStep === STEPPER_RECETAS.BUSCAR_TITULAR && (
          <RecetasDigitalesAfiliadoBuscador idObraSocial={idObraSocial} setIdObraSocial={setIdObraSocial}/>
        )}
        {activeStep === STEPPER_RECETAS.DATOS_TITULAR && (
          <RecetasDigitalesDatosTitular idObraSocial={idObraSocial}/>
        )}
        {activeStep === STEPPER_RECETAS.DETALLE_RECETA && (
          <RecetasDigitalesDetalleOrden idObraSocial={idObraSocial}/>
        )}
        {activeStep === STEPPER_RECETAS.MEDICAMENTOS && (
            <RecetasDigitalesMedicamentos idObraSocial={idObraSocial}/>
          )
        }
        {activeStep === STEPPER_RECETAS.CONFIRMACION && (
          <RecetasDigitalesConfirmacion idObraSocial={idObraSocial}/>
        )}
      </Grid>

    </React.Fragment>
  );
};
